export const CHAPTERS = {
  INTRO: 'intro',
  OPENING_CREDITS: 'opening_credits',
  ENDING_CREDITS: 'ending_credits',
};

export const EVENTS = {
  [CHAPTERS.INTRO]: 'skipIntro',
  [CHAPTERS.OPENING_CREDITS]: 'skipIntro',
  [CHAPTERS.ENDING_CREDITS]: 'skipCredits',
};
